import { SvgIconProps } from "@mui/material";
import { ExplainWithAiAnomaliesTypes } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/utils/types";
import { anomaliesIcons } from "@/components/pages/resource-explorer/components/explain-with-ai-panel/components/utils/constants";

interface AnomalyIconProps extends SvgIconProps {
  type: ExplainWithAiAnomaliesTypes;
  sx?: any;
}

export const AnomalyIcon = ({
  type,
  color,
  sx,
  fontSize,
}: AnomalyIconProps) => {
  const Icon = anomaliesIcons[type];
  return <Icon fontSize={fontSize} sx={sx} color={color} />;
};
